import { Form } from "antd";
import styled from "styled-components";

import { MARGINS } from "./FormItem.constants";
import { TMarginSize } from "./FormItem.types";

export const FormItemStyled = styled(Form.Item)<{ $marginSize: TMarginSize }>`
    margin-bottom: ${props => MARGINS[props.$marginSize]}
`;
